import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  updateDashboardProjectSlot,
  getDashboardProjectSlots,
  UpdateDashboardProjectSlotInput,
} from '@/features/dashboard/api/dashboard-project-slots';
import { useCurrentOrg } from '@/features/org/hooks/use-org';

export const dashboardProjectSlotsQueryKey = (orgId?: number) => [
  'dashboard-project-slots',
  orgId,
];

export const useDashboardProjectSlots = () => {
  const { data: org, isLoading: isOrgLoading } = useCurrentOrg();

  return useQuery({
    queryKey: dashboardProjectSlotsQueryKey(org?.id),
    queryFn: async () => {
      if (isOrgLoading || !org) {
        return null;
      }
      return getDashboardProjectSlots(org.id);
    },
    enabled: !isOrgLoading && !!org,
  });
};

export const useUpdateDashboardProjectSlot = () => {
  const queryClient = useQueryClient();
  const { data: org } = useCurrentOrg();

  return useMutation({
    mutationFn: async (input: UpdateDashboardProjectSlotInput) => {
      if (!org) {
        throw new Error('No organization selected');
      }
      return updateDashboardProjectSlot({
        orgId: org.id,
        slotIndex: input.slotIndex,
        projectId: input.projectId,
        isActive: input.isActive,
      });
    },
    onSuccess: () => {
      if (org) {
        queryClient.invalidateQueries({
          queryKey: dashboardProjectSlotsQueryKey(org.id),
        });
      }
    },
  });
};
